import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      requestTimout: null,
    };
  },
  computed: {
    ...mapGetters(['userDetails']),
  },
  methods: {
    hasRole(role) {
      if (role && this.userDetails && this.userDetails.roles.length) {
        if (Array.isArray(role)) {
          if (
            role.every((elem) => {
              return this.userDetails.roles.indexOf(elem) > -1;
            })
          ) {
            return true;
          }
        } else if (this.userDetails.roles.find((elem) => elem === role)) {
          return true;
        }
      }
      return false;
    },
  },
};
